import { defineStore } from "pinia";
import { ref } from "vue";

import userAccessService from "@/services/user-access.service";

export const useUserAccessesStore = defineStore("userAccesses", () => {
  // State
  const clients = ref([]);
  const permissions = ref(null);
  const permissionsLoading = ref(false);

  // Getters
  const getAccessibleClients = async () => {
    if (clients.value.length > 0) {
      return clients.value;
    }
    const response = await userAccessService.fetchAccessibleClients();
    clients.value = response.data || [];
    return clients.value;
  };
  const getUserPermissions = async () => {
    // Si ya tenemos permisos en caché, devolverlos inmediatamente
    if (permissions.value !== null) {
      return { data: permissions.value };
    }

    // Si ya hay una llamada en progreso, esperar a que termine
    if (permissionsLoading.value) {
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (!permissionsLoading.value && permissions.value !== null) {
            clearInterval(checkInterval);
            resolve({ data: permissions.value });
          }
        }, 50);
      });
    }

    // Realizar la llamada al backend
    try {
      permissionsLoading.value = true;
      const response = await userAccessService.fetchUserPermissions();
      permissions.value = response.data;
      return response;
    } finally {
      permissionsLoading.value = false;
    }
  };

  // Actions
  const resetState = () => {
    clients.value = [];
    permissions.value = null;
    permissionsLoading.value = false;
  };
  const switchToClient = async (id) => {
    await userAccessService.switchToClient(id);

    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  return {
    // State
    clients,
    permissions,
    // Getters
    getAccessibleClients,
    getUserPermissions,
    // Actions
    resetState,
    switchToClient,
  };
});
